import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { userService } from "../../../_services";
import FilterTagCom from '../FilterTag.jsx';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../ui/card";

// Import modernized widgets
import BarWidget from '../BarWidget';
import ColumnPieWidget from '../ColumnPieWidget';
import MultiLineWidget from '../MultiLineWidget';
import ClaimWidget from '../Claim';
import TableWidget from '../TableWidget';
import MultiStackBarWidget from '../MultiStackBarWidget';

/**
 * Admin Dashboard Component
 * Modernized with React hooks - Displays widgets for admin analytics
 */
function Dashboard({ startDate: propStartDate, endDate: propEndDate, dist_usertype, handeChangefilter, dashboardName: propDashboardName }) {
    // Initialize dates
    const getInitialStartDate = () => {
        const stored = localStorage.getItem('User_Start_Date');
        if (stored) return moment(stored).format("YYYYMMDD");
        return moment(new Date().setDate(new Date().getDate() - 30)).format("YYYYMMDD");
    };

    const getInitialEndDate = () => {
        const stored = localStorage.getItem('User_End_Date');
        return stored ? moment(stored).format("YYYYMMDD") : moment(new Date()).format("YYYYMMDD");
    };

    // State
    const [startDate, setStartDate] = useState(getInitialStartDate());
    const [endDate, setEndDate] = useState(getInitialEndDate());
    const [graphData, setGraphData] = useState([]);
    const [filterTagList, setFilterTagList] = useState('');
    const [counter, setCounter] = useState(0);
    
    const roleName = 'Admin';
    const whId = '61';
    const roleType = 'Admin';

    // Update dates when props change
    useEffect(() => {
        if (propStartDate && propEndDate) {
            const newStartDate = moment(propStartDate).format("YYYYMMDD");
            const newEndDate = moment(propEndDate).format("YYYYMMDD");
            
            if (startDate !== newStartDate || endDate !== newEndDate) {
                setStartDate(newStartDate);
                setEndDate(newEndDate);
                changeData(newStartDate, newEndDate);
            }
        }
    }, [propStartDate, propEndDate]);

    // Handle HD type changes
    useEffect(() => {
        const prevHDType = localStorage.getItem('Prev_HD_Type');
        const updatedHDType = localStorage.getItem('Updated_HD_Type');
        const filterLastUpdate = localStorage.getItem('Filter_Last_Update_Time');
        const filterPrevUpdate = localStorage.getItem('Filter_Prev_Update_Time');

        if ((prevHDType !== updatedHDType) || (filterLastUpdate !== filterPrevUpdate)) {
            if (prevHDType !== updatedHDType) {
                localStorage.setItem('Prev_HD_Type', updatedHDType);
            }
            if (filterLastUpdate !== filterPrevUpdate) {
                localStorage.setItem('Filter_Prev_Update_Time', filterLastUpdate);
            }
            changeData();
        }
    }, [counter]);

    // Initial data load
    useEffect(() => {
        localStorage.setItem('Filter_Last_Update_Time', new Date());
        changeData();
    }, []);

    const handleChangeA = (e) => {
        if (handeChangefilter) {
            handeChangefilter(e);
        }
    };

    const changeData = (newStartDate, newEndDate) => {
        const APIBaseURL = '/api/ws';
        const startDateStr = newStartDate || startDate;
        const endDateStr = newEndDate || endDate;

        // Parse advanced filter
        let AdFilterJson = '';
        let stringAdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                stringAdFilterJson = JSON.stringify(AdFilterJson);
                setFilterTagList(stringAdFilterJson);
            } else {
                setFilterTagList('');
            }
        } catch (error) {
            setFilterTagList('');
        }

        setCounter(prev => prev + 1);

        // Build request JSONs
        const TotalTransactions_PostData_RequestJson = JSON.stringify({
            wname: "61",
            wholesaler_id: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 0,
            chart_type: "columnList",
            ispatientsaving: "true",
            pharmacynumber: "all",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type')
        });

        const Gr_No_Transactions_PostData_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 30,
            chart_type: "columnList",
            ispatientsaving: "true",
            pharmacynumber: "all",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type'),
            wholesaler_id: "61"
        });

        const Unique_Members_Widget_PostData_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 0,
            chart_type: "columnList",
            ispatientsaving: "true",
            pharmacynumber: "all",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type'),
            wholesaler_id: "61"
        });

        const Drug_Transactions_Widget_PostData_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 30,
            chart_type: "pielist",
            ispatientsaving: "true",
            pharmacynumber: "all",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type'),
            wholesaler_id: "61"
        });

        const New_Repeat_Widget_PostData_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 30,
            chart_type: "multilinelist",
            ispatientsaving: "true",
            pharmacynumber: "all",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type'),
            wholesaler_id: "61"
        });

        const Claim_PostData_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 0,
            chart_type: "list",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type'),
            wholesaler_id: "61"
        });

        const Commission_MultiStack_Column_PostData_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 0,
            chart_type: "column_multiaxislist",
            ispatientsaving: "true",
            pharmacynumber: "all",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type')
        });

        const PatientSaving_Widget_Postdata_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 0,
            chart_type: "columnList",
            ispatientsaving: "true",
            pharmacynumber: "all",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type'),
            wholesaler_id: "61"
        });

        const Table_Pharmacy_RequestJson = JSON.stringify({
            wname: "61",
            start_date: startDateStr,
            end_date: endDateStr,
            rcount: 30,
            chart_type: "list",
            filtertime: localStorage.getItem('Filter_Last_Update_Time'),
            rxsClaimType: localStorage.getItem('Updated_HD_Type'),
            wholesaler_id: "61"
        });

        setGraphData([
            {
                url: APIBaseURL + "/total_transactions_new",
                type: "Bar",
                title: "Total Transactions",
                Subtitle: "Total number of transactions for each day",
                ColorCode: '#313131',
                DataType: "NA",
                XlabelString: "Date",
                YlabelString: "# of Transactions",
                interval: 'day',
                id: "WTotalTransaction",
                RequestJson: TotalTransactions_PostData_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/RXSClaims",
                type: "Claim",
                title: "Claim Counts",
                Subtitle: "",
                ColorCode: "#313131",
                id: "RxSensClaim",
                RequestJson: Claim_PostData_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/new_and_repeat_claims_Line",
                type: "MultiLine",
                title: "New vs Repeat Transactions",
                Subtitle: "New vs Repeat Compensable Transactions",
                ColorCode: "#f19f57",
                DataType: "NA",
                XlabelString: "Date",
                YlabelString: "# of Transactions",
                interval: 'day',
                id: "WNewRepeatMultiLine",
                RequestJson: New_Repeat_Widget_PostData_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/Transactions_By_Group_Number",
                type: "Bar",
                title: "Transactions by Group Number",
                Subtitle: "Number of transactions for each group number",
                ColorCode: "#313131",
                DataType: "GroupNumber",
                XlabelString: "Group Number",
                YlabelString: "# of Transactions",
                id: "WGroupNumberTransaction",
                RequestJson: Gr_No_Transactions_PostData_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/Total_PaitentSavings",
                type: "Bar",
                title: "Total Patient Savings ($)",
                Subtitle: "Total savings for all patients in $",
                ColorCode: '#313131',
                DataType: "NA",
                XlabelString: "Date",
                YlabelString: "Total Savings",
                id: "WPatientSavings",
                RequestJson: PatientSaving_Widget_Postdata_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/Drug_Wise_Transaction",
                type: "ColumnPie",
                title: "Transactions by Drug",
                Subtitle: "Number of transactions for each drug",
                ColorCode: "#313131",
                DataType: "DrugName",
                XlabelString: "Date",
                YlabelString: "# of Unique Member ID's",
                interval: 'day',
                id: "WDrugTransaction",
                RequestJson: Drug_Transactions_Widget_PostData_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/EarnedCommission",
                type: "MultiStackBar",
                title: "Total Revenue Earned",
                Subtitle: "Revenue earned for each month",
                ColorCode: "#f19f57",
                DataType: "NA",
                XlabelString: "Date",
                YlabelString: "Commission",
                interval: 'month',
                id: "WEarnedCommission",
                RequestJson: Commission_MultiStack_Column_PostData_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/prescribe_transaction",
                type: "Table",
                title: "Transactions by Prescriber",
                Subtitle: "Number of transactions at each Prescriber",
                ColorCode: "#ffba10",
                XlabelString: "",
                YlabelString: "",
                id: "WPrescriberTransaction",
                RequestJson: Table_Pharmacy_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/Unique_Members_Widget",
                type: "Bar",
                title: "Unique Member ID's",
                Subtitle: "Number of unique members transacted on each day",
                ColorCode: "#313131",
                DataType: "NA",
                XlabelString: "Date",
                YlabelString: "# of Unique Member ID's",
                interval: 'day',
                id: "WUniqueMembersWidget",
                RequestJson: Unique_Members_Widget_PostData_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            }
        ]);
    };

    // Get widget layout classes
    const getWidgetClasses = (widgetId) => {
        const layoutMap = {
            'WTotalTransaction': 'col-span-12',
            'RxSensClaim': 'col-span-12',
            'WNewRepeatMultiLine': 'col-span-12',
            'WGroupNumberTransaction': 'col-span-12',
            'WPatientSavings': 'col-span-12',
            'WDrugTransaction': 'col-span-12',
            'WEarnedCommission': 'col-span-12',
            'WPrescriberTransaction': 'col-span-12',
            'WUniqueMembersWidget': 'col-span-12'
        };

        return layoutMap[widgetId] || 'col-span-12';
    };

    // Render widget based on type
    const renderWidget = (widget, index) => {
        const commonProps = {
            data: widget,
            key: `widget-${widget.id}-${index}`,
            _Index: index,
            handlechangea: handleChangeA
        };

        switch (widget.type) {
            case 'Bar':
                return <BarWidget {...commonProps} />;
            case 'ColumnPie':
                return <ColumnPieWidget {...commonProps} />;
            case 'MultiLine':
                return <MultiLineWidget {...commonProps} />;
            case 'Claim':
                return <ClaimWidget {...commonProps} />;
            case 'Table':
                return <TableWidget {...commonProps} />;
            case 'MultiStackBar':
                return <MultiStackBarWidget {...commonProps} />;
            default:
                return null;
        }
    };

    return (
        <div className="w-full space-y-6">
            {/* Filter Tags */}
            <FilterTagCom 
                Rolename={roleName}
                wh_Id={whId}
                Roletype={roleType}
                df={startDate}
                dt={endDate}
                handlechangea={handleChangeA}
                FilterTags={filterTagList}
                Loading={true}
            />

            {/* Widgets Grid */}
            <div className="grid grid-cols-12 gap-6">
                {graphData.map((widget, index) => {
                    // Special handling for Claim widget - no parent card
                    if (widget.type === 'Claim') {
                        return (
                            <div 
                                key={`widget-${widget.id}-${index}`}
                                className={getWidgetClasses(widget.id)}
                            >
                                <ClaimWidget 
                                    data={widget}
                                    key={`${widget.type}-${index}`}
                                    _Index={index}
                                    handlechangea={handleChangeA}
                                />
                            </div>
                        );
                    }
                    
                    // Regular widgets with card wrapper
                    return (
                        <Card 
                            key={`widget-${widget.id}-${index}`}
                            className={getWidgetClasses(widget.id)}
                        >
                            <CardHeader className="border-b px-6 py-4">
                                <CardTitle className="text-lg font-semibold text-brand-dark">
                                    {widget.title}
                                </CardTitle>
                                {widget.Subtitle && (
                                    <CardDescription className="text-sm text-brand-dark/70 mt-1">
                                        {widget.Subtitle}
                                    </CardDescription>
                                )}
                            </CardHeader>
                            <CardContent className="p-6">
                                {renderWidget(widget, index)}
                            </CardContent>
                        </Card>
                    );
                })}
            </div>
        </div>
    );
}

export default Dashboard;
